export enum OrderButtonTitle {
  Default = 'Оформить заказ',
  Sending = 'Заказ оформляется...'
}
